import {
  HomeOutlined,
  InfoCircleOutlined,
  UsergroupAddOutlined,
  PhoneOutlined,
  FileTextOutlined,
  CalendarOutlined,
  SmileOutlined,
  BookOutlined,
  ProfileOutlined,
} from "@ant-design/icons";

export const MENU_ITEMS = [
  {
    label: "หน้าหลัก",
    key: "/",
    icon: <HomeOutlined />,
  },
  {
    label: "รู้จักเรา",
    key: "about-us",
    icon: <InfoCircleOutlined />,
  },
  {
    label: "สมัครสมาชิก",
    key: "registration",
    icon: <UsergroupAddOutlined />,
  },
  {
    label: "ถวาย",
    key: "support-us",
    icon: <SmileOutlined />,
  },
  {
    label: "พันธกิจ",
    key: "SubMenu",
    icon: <ProfileOutlined />,
    children: [
      {
        label: "ส่งเสริมการอ่านพระคัมภีร์/BIBLE MINISTRY",
        key: "bible-ministry",
        disabled: true,
      },
      {
        label: "รวีวารศึกษา/SUNDAY SCHOOL MINISTRY",
        key: "sunday-school-ministry",
        disabled: true,
      },
      {
        label: "ค่ายเด็ก/CHILDREN’S CAMP",
        key: "children-camp",
        disabled: true,
      },
    ],
  },
  {
    label: "อ่านพระคัมภีร์ใน 1 ปี",
    key: "/bible-1-year",
    icon: <FileTextOutlined />,
    disabled: false,
  },
  {
    label: "พลังประจำวัน",
    key: "daily-bread",
    icon: <CalendarOutlined />,
  },
  {
    label: "หนังสือ",
    key: "books",
    icon: <BookOutlined />,
    children: [
      {
        label: "Big Bible Challenge",
        key: "big-bible",
      },
      {
        label: "Hotshots",
        key: "hotshots",
      },
      {
        label: "E100",
        key: "e100",
      },
      {
        label: "Pray the word",
        key: "pray-the-word",
        disabled: true,
      },
    ],
  },
  {
    label: "ติดต่อ",
    key: "contact-us",
    icon: <PhoneOutlined />,
  },
];
